import { useState } from 'react'

import type { Invoice } from 'services/commerce/types'
import {
  claimOrder,
  fetchInvoice,
  fulfillItem,
  sendReclaimToken,
} from 'services/commerce'

function useOnRampOrder(userId?: string) {
  const [invoice, setInvoice] = useState<Invoice | null>(null)
  const [isFulfilling, setIsFulfilling] = useState(false)
  const [hasSentReclaimToken, setHasSentReclaimToken] = useState(false)

  async function handleClaimOrder(orderId: string, claimToken?: string) {
    if (userId) {
      try {
        const order = await claimOrder(orderId, userId, claimToken)

        const invoice = await fetchInvoice(order.invoiceId)

        setInvoice(invoice)
      } catch (error) {
        if (error.message === 'claim window has expired') {
          await sendReclaimToken(orderId, userId)
          setHasSentReclaimToken(true)
          return
        } else {
          throw error
        }
      }
    }
  }

  async function handleFulfillOrder() {
    if (!invoice) {
      return
    }

    setIsFulfilling(true)

    try {
      await fulfillItem(invoice.id, invoice.lineItems[0].id)
    } catch (error) {
      setIsFulfilling(false)
      throw error
    }
  }

  return {
    claimOrder: handleClaimOrder,
    orderFetched: !!invoice,
    fulfillOrder: handleFulfillOrder,
    isFulfilling,
    hasSentReclaimToken,
  }
}

export default useOnRampOrder
